// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2AvVy","inputDescription":"styles_inputDescription__1eHpL"};